// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var OrganizationName = function (x) {
    return x;
};
var tsBridgeOrganizationName = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("OrganizationName")("__brandOrganizationName"));
    }
};
var writeOrganizationName = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showOrganizationName = Data_Show.showString;
var readOrganizationName = Simple_JSON.readString;
var ordOrganizationName = Data_Ord.ordString;
var newtypeOrganizationName = {
    Coercible0: function () {
        return undefined;
    }
};
var makeOrganizationName = OrganizationName;
var eqOrganizationName = Data_Eq.eqString;
export {
    OrganizationName,
    makeOrganizationName,
    unwrap,
    newtypeOrganizationName,
    eqOrganizationName,
    ordOrganizationName,
    showOrganizationName,
    readOrganizationName,
    writeOrganizationName,
    tsBridgeOrganizationName
};
//# sourceMappingURL=index.js.map
